import { Col, Row } from 'antd';
import React from 'react';
import ButtonsOption from './optionTypes/ButtonsOption';
import SelectOption from './optionTypes/SelectOption';
import TextOption from './optionTypes/TextOption';
import useScrollTo from '../hooks/useScrollTo';

const Question = ({ question, selectOption, hasToScroll }) => {
  const { ref } = useScrollTo(hasToScroll)
  const maxLengthOptions = 15;

  return (
    <Row justify="center" ref={ref}>
      <Col xs={24} md={16} xxl={12} xl={12} lg={16}>
        {
          question &&
          <Row justify='center'>
            <Col span={24} className='disclaimer-container mt-30'>
              <Row>
                <Col span={24}>
                  <p className='text-center mr-50 ml-50 mb-30'>
                    <strong>{question.order}.</strong> {question.title}
                  </p>
                </Col>
                <Col span={24}>
                  {
                    question.type === 'select' || question.type === 'select_multiple' || question.type === 'radio' ?
                      (question.type !== 'select_multiple' && question.options?.length > maxLengthOptions ?
                        <SelectOption question={question} selectOption={selectOption} /> :
                        <ButtonsOption question={question} selectOption={selectOption} />
                      )
                      : <TextOption question={question} selectOption={selectOption} />
                  }
                </Col>
              </Row>
            </Col>
          </Row>
        }
      </Col>
    </Row>
  )
}

export default Question;